module.exports = __webpack_public_path__ + "img/undraw_campfire_s6y4.14b8d465.svg";